const $win = $(window);
const fixedSectionClass = '.js-fixed-section'
const $fixedSection = $(fixedSectionClass);

const fixedScrolling = ($element, className) => {
  const winTop = $win.scrollTop();
  const winHeight = $win.height();
  const winBottom = winTop + winHeight;
  const winHalf = winTop + (winHeight/2);

  $element.each(function(idx) {
    const $section = $(this);
    const sectionOffset = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const sectionBottomPos = sectionOffset + sectionHeight;

    if (sectionOffset < winHalf && sectionBottomPos > winHalf) {
      $section
        .addClass('expanded')
        .siblings()
        .removeClass('expanded');

      $section
        .parent()
        .siblings()
        .find(fixedSectionClass)
        .removeClass('expanded');

      if (($element.length - 1) == idx && sectionBottomPos < winBottom) {
        $section.addClass('static');
      } else {
        $section.removeClass('static');
      }
    };
  });
}

$win.on('load scroll', function() {
  if ($win.width() > 767) {
    fixedScrolling($fixedSection, fixedSectionClass)
  };
});



// WEBPACK FOOTER //
// ../assets/js/fixed-sections.js